// @ts-ignore
const SECTION_NAME = "lookbook-video";
const BREAKPOINT_VIDEO = 640;

/** @param {HTMLElement} baseElement */
export function init(baseElement) {
  if (baseElement) {
    const buttonSoundControl = baseElement.querySelector(
      ".button-sound-control"
    );

    buttonSoundControl.addEventListener("click", function(e) {
      e.preventDefault();
      toggleVideoSound(buttonSoundControl, baseElement);
    });
  }
}

function toggleVideoSound(buttonElement, baseElement) {
  const videoDesktopEl = baseElement.querySelector(".lookbook-desktop-video");
  const videoMobileEl = baseElement.querySelector(".lookbook-mobile-video");
  let activeVideo;

  if (window.innerWidth < BREAKPOINT_VIDEO) {
    activeVideo = videoMobileEl;
  } else {
    activeVideo = videoDesktopEl;
  }

  if (!activeVideo) return;
  if (activeVideo.muted) {
    activeVideo.muted = false;
    buttonElement.innerText = "Sound On";
  } else {
    activeVideo.muted = true;
    buttonElement.innerText = "Sound Off";
  }
}
